// 2024-03-28 switched from cscs to proj4
// DO NOT USE ol method geom.getLength() or geom.getArea() with epsg:3857 because it's cartesian
// ol does provide spherical lengths and areas with getLength(geom) and getArea(geom) which require:
// import {getArea, getLength} from '../node_modules/ol/sphere.js';


/**
 * Returns total length of line in feet (unformatted number)
 * called in LayerStyle.js and Tooltip.js
 */

export default function(line) {
  let length = 0
  let cartesian = rwg.proj.cartesianSRID

  if (cartesian) {

    const map = rwg.proj.mapSRID
    const vertices = line.getCoordinates()
    const count = vertices.length
    let p1 = rwg.proj.transform(map, cartesian, vertices[0])
    let p2, dx, dy
    for (let i = 1; i < count; ++i) {
      p2 = rwg.proj.transform(map, cartesian, vertices[i])
      dx = p2[0] - p1[0]
      dy = p2[1] - p1[1]
      length += Math.hypot(dx, dy);
      p1 = p2
    }

    if (rwg.proj.cartesianMetersPerUnit === 1) {
      length = length * 3.28084
    }
  } // else rwg.proj.cartesianSRID not set

  return length
}
